import Api from "./Api";

export default {

    obtenerTrucoDelDia() {
        return Api().get("/trick-of-the-day");
    },

    obtenerPorDificultad(dificultad) {
        return Api().get(
            `/trucos/dificultad/${dificultad}`
        );
    },

    obtenerPorSlug(slug) {
        return Api().get(
            `/trucos/${slug}`
        );
    },

    obtenerTrucosAZ() {
        return Api().get(
            "/trucos/a-z"
        );
    },

};